import React from 'react';
import { IMaskInput } from 'react-imask';

interface CustomMaskedInputProps {
  name: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  mask: any;
  blocks?: any;
  prepare?: (str: string) => string;
  inputRef?: React.Ref<HTMLInputElement>;
}

const MaskedTextInput = React.forwardRef<
  HTMLInputElement,
  CustomMaskedInputProps
>(function MaskedTextInput({ onChange, mask, blocks, prepare, ...props }, ref) {
  return (
    <IMaskInput
      {...props}
      mask={mask}
      blocks={blocks}
      prepare={prepare}
      inputRef={ref}
      overwrite
      unmask={true}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
    />
  );
});

export default MaskedTextInput;
